import MonacoEditor, { EditorProps } from '@monaco-editor/react';
import { FC } from 'react';
import { MONACO_OPTIONS } from './config';

export const Editor: FC<EditorProps> = (props) => <MonacoEditor options={MONACO_OPTIONS} theme="vs-dark" {...props} />;
